import * as ReactIs from "react-is";

export const isValidElementType = (ele) => ReactIs.isValidElementType(ele);

export const isElement = (ele) => ReactIs.isElement(ele);

export const isFragment = (ele) => ReactIs.isFragment(ele);
